// @flow
import {createInfoWindowContent} from './createInfoWindowContent'

export const makeMapMarkers = (map:GoogleMap, serviceProviders: ServiceProvider[], icon: string):MapMarker[] => {
  const google = window.google
  const infoWindow:InfoWindow = new google.maps.InfoWindow()
  const markers = serviceProviders.map(function(s, i) {
    if (!s.location) return null
    const marker = new google.maps.Marker({
      position: {
        lat: s.location.latitude,
        lng: s.location.longitude,
      },
      title: s.name,
      map: map,
      icon: icon,
    })
    
    marker.addListener('click', function(){
      infoWindow.setContent(createInfoWindowContent(s))
      infoWindow.open(map, marker)
    })
    return marker
  })
  return markers.filter(Boolean)
}